<template>
  <b-card class="shadow atm-rounded">
    <section v-if="currentWeekTasksData.length">
      <table class="table table-bordered table-responsive">
        <thead>
          <tr>
            <th
              class="w-25 text-center"
              v-for="(label, index) in labelsForTheTableHeader"
              :key="index"
            >
              <p class="m-0">{{ label }}</p>
            </th>
          </tr>
        </thead>
        <tbody class="body-table">
          <tr
            v-for="(tasks, index) in currentWeekTasksData"
            :key="index"
            :style="{ backgroundColor: getTaskColor(tasks.state) }"
          >
            <td>
              {{ tasks.strState }}
            </td>
            <td class="text-center align-middle">
              {{ tasks.countTasks }}
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </b-card>
</template>

<script>
import { colorsByState } from '@/dashboard/constants';

export default {
  props: {
    currentWeekTasks: Array,
  },
  data() {
    return {
      labelsForTheTableHeader: ['Assignment Activities', 'This week'],
      currentWeekTasksData: [],
    };
  },
  methods: {
    getTaskColor(state) {
      return colorsByState[state];
    },
  },
  watch: {
    currentWeekTasks: {
      handler(newVal) {
        if (newVal) this.currentWeekTasksData = newVal;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
